// Confirmation dialog before deleting something (users, projects).
import { Modal } from "antd";

export const showConfirmDelete = (
  itemName,
  onConfirm,
  close,
  _additionalWarning = "",
) => {
  Modal.confirm({
    title: "Confirm Deletion",
    content: (
      <>
        Are you sure you want to delete "{itemName}"? This action cannot be
        undone.
        {_additionalWarning && (
          <>
            <br />
            <span style={{ color: "red" }}>{_additionalWarning}</span>
          </>
        )}
      </>
    ),
    okText: "Delete",
    okType: "danger",
    cancelText: "Cancel",
    onOk() {
      onConfirm();
    },
    onCancel() {
      close();
      // Handle cancel action if needed
    },
  });
};
